import { Box } from '@chakra-ui/react';
import { EntityType } from '@texas/api/endpoints/trackerApi';
import { EntityTagLinks } from '@texas/components/tags/EntityTagLinks';
import { ManagementCard } from './ManagementCard';
import { useTranslation } from 'react-i18next';

export function TagsManagement({ articleId }: { articleId: number }) {
  const { t } = useTranslation();
  return (
    <ManagementCard
      title={t('article.management.tags')}
      description={t('article.management.tagsDescription')}
    >
      <Box minH="180px">
        <EntityTagLinks entityId={articleId} entityType={EntityType.Article} />
      </Box>
    </ManagementCard>
  );
}
